// Primeira linha SEMPRE: garante que `__CRM_REACT__` e
// `__CRM_REACT_ROUTER_DOM__` já estão presos no `globalThis` ANTES de
// qualquer outro módulo do grafo rodar (inclusive antes do `useAuth.js`
// anexar interceptors do axios na carga do módulo, que era o ponto que
// criava o ciclo de imports e fazia o `react` chegar null em HMR).
import "./bootstrap";

import React from "react";
import { createRoot } from "react-dom/client";
import "./globals.css";

import App from "./App";
import ErrorBoundary from "./ErrorBoundary";

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Service Worker do PWA. Registrado aqui, sem import nenhum de propósito:
// assim ele não participa do grafo de módulos nem interfere na ordem de boot
// que o ./bootstrap garante. Só em produção — em dev o SW cachearia os
// módulos do Vite e o HMR passaria a servir arquivo velho.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
